// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-option p{margin:0}.correct-radio .custom-control-label:before{background-color:#2cb774!important;border-color:#2cb774!important}.error-radio .custom-control-label:before{background-color:#c00!important;border-color:#c00!important;font-weight:700!important}.correct-text{color:#2cb774!important;font-weight:700!important}.error-text{color:#c00!important;font-weight:700!important}", ""]);
// Exports
module.exports = exports;
